import Base from '../../ts/_base';

export default class CookiePolicy extends Base {
    private fetchUrl: string = "/action/cookiePolicy?response=accept";
    
    private get childSelectors(): {[key: string]: string} {
        return {
            widget: '.cookie-policy',
            close: '.cookie-policy .btn',
            moreLink: '.cookie-policy p a'
        }
    }
    public initialize(): void {
        this.control();
    }

    private control(): void {
        this.subscribeToEvent('click', this.childSelectors.close, this.acceptCookie.bind(this))
        const link: HTMLElement = this.queryElm(this.childSelectors.moreLink) as HTMLElement;
        link?.focus();
    }

    private async acceptCookie(e: MouseEvent): Promise<void> {
        e.preventDefault();
        const widget: HTMLElement = this.queryElm(this.childSelectors.widget) as HTMLElement;
        try {
            await fetch(this.fetchUrl);
        } catch(e) {
            this.showWarn("error accepting cookie policy")
        }
        widget.remove();
    }
}

